import React from 'react'
import Wysiwyg from '~/components/core/Wysiwyg/Wysiwyg'
import transformLink from '~/utils/transformLink'
import LinkIcon from '~/components/core/linkIcon'

// import { ContactPhoneGradient } from '~/icons/ContactPhoneGradient';
// import { ContactDocGradient } from '~/icons/ContactDocGradient';
// import { ContactLinkGradient } from '~/icons/ContactLinkGradient';
// import { ContactProfileGradient } from '~/icons/ContactProfileGradient';

// import { ContactPhone } from '~/icons/ContactPhone';
// import { ContactDoc } from '~/icons/ContactDoc';
// import { ContactLink } from '~/icons/ContactLink';
// import { ContactProfile } from '~/icons/ContactProfile';

import contactPhoneIconGradient from '~/icons/contact-phone-gradient.svg'
import contactDocIconGradient from '~/icons/contact-doc-gradient.svg'
import contactLinkIconGradient from '~/icons/contact-link-gradient.svg'
import contactProfileIconGradient from '~/icons/contact-profile-gradient.svg'

import contactPhoneIcon from '~/icons/contact-phone.svg'
import contactDocIcon from '~/icons/contact-doc.svg'
import contactLinkIcon from '~/icons/contact-link.svg'
import contactProfileIcon from '~/icons/contact-profile.svg'

const ContactItem = ({ data, type, title = 'h4', isAction = false }) => {
  const item = data.fields ? data.fields : data
  const link = item.link
    ? item.link.fields
      ? item.link.fields
      : item.link
    : null
  const { url, external, mailto, contentTypeContentful } = transformLink(
    link,
    true,
    false,
  )
  const typesGradient = ['accordion', 'project', 'profile']

  const renderIcon = (typeIcon) => {
    switch (typeIcon) {
      case 'phone':
        return (
          <use
            xlinkHref={`#${typesGradient.includes(type) ? contactPhoneIconGradient.id : contactPhoneIcon.id}`}
          />
        )
      case 'doc':
        return (
          <use
            xlinkHref={`#${typesGradient.includes(type) ? contactDocIconGradient.id : contactDocIcon.id}`}
          />
        )
      case 'link':
        return (
          <use
            xlinkHref={`#${typesGradient.includes(type) ? contactLinkIconGradient.id : contactLinkIcon.id}`}
          />
        )
      case 'profile':
        return (
          <use
            xlinkHref={`#${typesGradient.includes(type) ? contactProfileIconGradient.id : contactProfileIcon.id}`}
          />
        )
      default:
        return 'error'
    }
  }

  return (
    <div className="flex">
      <svg width="48" height="48" className="flex-shrink-0 mr-4">
        {renderIcon(item.icon)}
      </svg>
      <div className="pt-1">
        {title === 'h3' ? (
          <h3 className="text-label text-label--purple">{item.title}</h3>
        ) : (
          <h4 className="text-label text-label--purple">{item.title}</h4>
        )}

        {item.content !== null && (
          <Wysiwyg classes="paragraph--small" document={item.content} />
        )}

        {link && (
          <LinkIcon
            text={link.label}
            link={url}
            small="true"
            color={type === 'tab' ? 'white' : 'blue'}
            className="mt-2"
            external={external}
            mailto={mailto}
            contentType={contentTypeContentful}
          />
        )}
      </div>
    </div>
  )
}

export default ContactItem
